import { render, staticRenderFns } from "./product_menu.vue?vue&type=template&id=01c2997a&scoped=true&"
import script from "./product_menu.vue?vue&type=script&lang=js&"
export * from "./product_menu.vue?vue&type=script&lang=js&"
import style0 from "./product_menu.vue?vue&type=style&index=0&id=01c2997a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c2997a",
  null
  
)

export default component.exports